import { useQuery } from '@tanstack/react-query';
import { getEVInsights } from '../../../lib/api/financialApi';

/**
 * React Query hook for AI-powered EV and EV/EBITDA multiple insights.
 *
 * Stale time is set to 1 hour since this is a heavyweight LLM call.
 * Pass null as companyName to disable the query.
 *
 * When `competitors` is non-empty the backend returns analysis_type
 * "competitive" with both self_performance and competitive_performance blocks.
 * The competitors list is part of the query key so toggling produces two
 * distinct cache entries.
 */
export const useEVInsights = (
  companyName: string | null,
  years = 10,
  competitors?: string[]
) => {
  // Sort to keep query key stable regardless of caller ordering.
  const sortedCompetitors = competitors && competitors.length > 0
    ? [...competitors].sort()
    : undefined;

  return useQuery({
    queryKey: ['financial', 'ev-insights', companyName, years, sortedCompetitors],
    queryFn: () =>
      getEVInsights({
        company_name: companyName!,
        years,
        competitors: sortedCompetitors,
      }),
    enabled: !!companyName,
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: 1,
  });
};
